// @flow
import React, {useEffect, useState} from 'react';
import Experiment, {Variant} from '@homeaway/react-experiment';
import {SVGIcon} from '@homeaway/react-svg';
import {VIEWED_COLOR__24} from '@homeaway/svg-defs';
import {FormattedMessage} from 'react-intl';
import {VRBO_SERP_SEE_MORE_PROMPT} from '../../../abacus/experiments';

type Props = {
    onDemote: Function
};

// this could be renamed in the scope of next changes
const ThanksNo = ({onDemote}: Props) => {
    const [isVisible, setIsVisible] = useState(true);
    useEffect(() => {
        onDemote();
        setTimeout(() => {
            setIsVisible(false);
        }, 3000);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        isVisible && (
            <div className="ThanksNo__wrapper">
                <div className="ThanksNo">
                    <Experiment name={VRBO_SERP_SEE_MORE_PROMPT} deferLogging>
                        <Variant variant={1}>
                            <SVGIcon
                                markup={VIEWED_COLOR__24}
                                className={'ThanksNo__icon'}
                            />
                        </Variant>
                    </Experiment>
                    <p className="ThanksNo__text">
                        <FormattedMessage
                            id="seeMorePrompt.propertyMoved"
                            description="Thanks! We've moved this property to the bottom of the list."
                            defaultMessage="Thanks! We've moved this property to the bottom of the list."
                        />
                    </p>
                </div>
            </div>
        )
    );
};

export default ThanksNo;
